import { Container, Box, Stack } from "@mui/material";
import HeroSlider from "../components/HeroSlider/HeroSlider";
import SearchHospital from "../components/SearchHospital/SearchHospital";
import FAQs from "../components/Sections/FAQs/FAQs";
import OurFamilies from "../components/Sections/OurFamilies/OurFamilies";
import Blogs from "../components/Sections/Blogs/Blogs";
import PatientCaring from "../components/Sections/PatientCaring/PatientCaring";
import Specialization from "../components/Sections/Specialization/Specialization";
import HeroServices from "../components/IconLayout/HeroServices";
import Investigation from "../components/IconLayout/Investigation";
import About from "../components/Sections/PatientCaring/About";
import banner from "../assets/vem_banners-03-1.jpg";
import {useEffectOnce} from "../redux/hooks/useEffectOnce";
import {actionToGetBlogDataApiCall} from "../redux/action";
import {useDispatch} from "react-redux";
import Specialists from "../components/Sections/Specialists/Specialists";
import Reviews from "../components/Sections/Reviews/Reviews";
export default function Home() {
    const dispatch = useDispatch();
    useEffectOnce(() => {
        dispatch(actionToGetBlogDataApiCall());
    });
  return (
    <Box sx={{}}>
      <Box
          sx={{
              backgroundImage: `url(${banner})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundAttachment: "fixed",
          }}
        mb={4}
      ><Container maxWidth="xl">
          {/* hero section, with doc images and text */}
          <HeroSlider />
          <Stack
            p={{ xs: 2.5, md: 8 }}
            mt={{ xs: 2, md: 2, lg: 6, xl: 10 }}
            position="relative"
            zIndex={99}
            bgcolor="#fff"
            borderRadius="15px"
            spacing={10}
            boxShadow="0 0 12px rgba(0,0,0,0.1)"
          >

            <HeroServices />
            <Investigation />
          </Stack>
        </Container>
      </Box>
      <About />

        {/*<Specialists/>*/}

      <Specialization />

      <PatientCaring />


      <Blogs />

      <OurFamilies />
        <Reviews/>
      <FAQs />

    </Box>
  );
}
